import styled from 'styled-components';

import { colors } from '@crm-framework/theme';

export const MenuItem = styled.li`
  margin-bottom: 5px;
`;

export const StyledMenuIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  cursor: pointer;

  &:hover {
    background-color: ${colors.SECONDARY_HOVER};
  }
`;
